import { axiosProvider } from '@/app/core/axios';
import { ProgramWizardSaveProps } from '@/app/core/components/program-wizard';
import { getCurrentFeatureCode } from '@/app/core/auth';
import {
  getShortNameForProductToLower,
  ProgramDataType,
  ProgramStatus,
} from '@ssar-app/domain';

export const saveHandler = async (
  programName: string,
  draftId: string,
  programId: string,
  data: ProgramDataType,
): Promise<ProgramWizardSaveProps> => {
  if (data) {
    if (
      programName &&
      programName.trim().length >= 3 &&
      programName.length <= 200
    ) {
      data.status = ProgramStatus.Draft;
      return submitDraft(data, draftId, programId)
        .then((response) => {
          return Promise.resolve({
            draftId: response['newDraftId'],
            programId: response['programId'],
            error: '',
          });
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    } else {
      return Promise.resolve({
        draftId: '',
        programId: '',
        error:
          programName.trim().length < 3
            ? 'Program Name must be at least 3 characters to save it as a Draft'
            : 'Program Name must be at most 200 characters',
      });
    }
  } else {
    return Promise.resolve({
      draftId: '',
      programId: '',
      error: 'Invalid program data.',
    });
  }
};

const submitDraft = (
  data: ProgramDataType,
  draftId: string,
  programId: string,
): Promise<Record<string, string>> => {
  return new Promise((resolve, reject) => {
    // console.log(JSON.stringify(model));
    axiosProvider.apiClient
      .post(
        `/program/${getShortNameForProductToLower(
          getCurrentFeatureCode() || '',
        )}/save/draft`,
        {
          program: data,
          draftId: draftId,
          programId: programId,
        },
      )
      .then((response) => {
        const { data } = response;
        if (data.resultCode === 0) {
          resolve(data.data);
        } else {
          throw new Error(
            (data?.messages || []).join('\\n') || data.statusText,
          );
        }
      })
      .catch((error) => {
        reject(error.response?.data || error);
      });
  });
};
